<!-- Template modificat -->
<div class="pdf-details-dialog">
    <!-- Header -->
    <div class="dialog-header">
        <h2 class="dialog-title">{{ data.rowData.display_name }}</h2>
        <div class="header-actions">
            <button mat-icon-button (click)="downloadPdf()" title="Download PDF">
                <mat-icon>download</mat-icon>
            </button>
            <button mat-icon-button (click)="closeDialog()" title="Închide" (dblclick)="forceCloseDialog()"
                class="close-dialog-btn">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>

    <!-- Main Content -->
    <div class="dialog-content">
        <!-- PDF Viewer Section (75%) -->
        <div class="pdf-viewer-section">
            <!-- PDF Toolbar -->
            <div class="pdf-toolbar">
                <div class="toolbar-left">
                    <button mat-icon-button (click)="previousPage()" [disabled]="currentPage <= 1"
                        title="Pagina anterioară">
                        <mat-icon>chevron_left</mat-icon>
                    </button>

                    <div class="page-navigation">
                        <span class="page-info">{{ currentPage }}</span>
                        <span class="page-info">din {{ totalPages }}</span>
                    </div>

                    <button mat-icon-button (click)="nextPage()" [disabled]="currentPage >= totalPages"
                        title="Pagina următoare">
                        <mat-icon>chevron_right</mat-icon>
                    </button>

                    <!-- View Mode Toggle -->
                    <div class="view-mode-toggle">
                        <mat-button-toggle-group [(ngModel)]="viewMode" (change)="onViewModeChange()">
                            <mat-button-toggle value="single" title="Vizualizare pagină singulară">
                                <mat-icon>description</mat-icon>
                            </mat-button-toggle>
                            <mat-button-toggle value="grid" title="Vizualizare grid pagini">
                                <mat-icon>grid_view</mat-icon>
                            </mat-button-toggle>
                        </mat-button-toggle-group>
                    </div>

                    <!-- Group Selection Button (visible only in single view + selection mode) -->
                    <div class="group-selection-controls" *ngIf="viewMode === 'single' && isSelectionMode">
                        <button mat-raised-button [color]="isCurrentPageSelected() ? 'warn' : 'primary'"
                            (click)="toggleCurrentPageInGroup()" class="page-group-btn">
                            <mat-icon>{{ isCurrentPageSelected() ? 'remove_circle' : 'add_circle' }}</mat-icon>
                            {{ isCurrentPageSelected() ? 'Scoate din grup' : 'Adaugă în grup' }}
                        </button>
                    </div>
                </div>

                <div class="toolbar-center">
                    <span class="document-info">{{ data.rowData.display_name }}</span>
                </div>

                <div class="toolbar-right">
                    <div class="zoom-control">
                        <button mat-icon-button (click)="zoomOut()" title="Micșorează" class="zoom-btn">
                            <mat-icon>remove</mat-icon>
                        </button>

                        <div class="zoom-slider-container">
                            <div class="word-slider-wrapper">
                                <input type="range" class="word-slider" min="25" max="300" step="5"
                                    [value]="zoomPercentage" (input)="onZoomSliderChange($event)">
                                <div class="slider-track"></div>
                                <div class="slider-fill" [style.width.%]="(zoomPercentage - 25) / (300 - 25) * 100">
                                </div>
                            </div>
                        </div>

                        <button mat-icon-button (click)="zoomIn()" title="Mărește" class="zoom-btn">
                            <mat-icon>add</mat-icon>
                        </button>

                        <div class="zoom-display">
                            <span class="zoom-value">{{ zoomPercentage }}%</span>
                        </div>
                    </div>

                    <div class="action-buttons">
                        <button mat-icon-button (click)="fitToWidth()" title="Încadrează în lățime">
                            <mat-icon>fit_screen</mat-icon>
                        </button>
                        <button mat-icon-button (click)="rotateLeft()" title="Rotește stânga">
                            <mat-icon>rotate_left</mat-icon>
                        </button>
                        <button mat-icon-button (click)="rotateRight()" title="Rotește dreapta">
                            <mat-icon>rotate_right</mat-icon>
                        </button>
                    </div>
                </div>
            </div>

            <!-- Page Selection Bar - MODIFICAT cu checkbox -->
            <div class="page-selection-bar" *ngIf="isSelectionMode">
                <div class="selection-info">
                    <mat-chip-set>
                        <mat-chip class="selection-info-chip">
                            Mod Selecție: {{ selectedPages.length }} pagini selectate
                        </mat-chip>
                    </mat-chip-set>

                    <!-- Checkbox Select All - doar când nu sunt pagini selectate SAU când sunt toate selectate -->
                    <mat-checkbox *ngIf="selectedPages.length === 0 || areAllPagesSelected()"
                        [checked]="areAllPagesSelected()"
                        [indeterminate]="selectedPages.length > 0 && !areAllPagesSelected()"
                        (change)="toggleSelectAll()" class="select-all-checkbox" color="primary">
                        Toate
                    </mat-checkbox>
                </div>

                <div class="selection-actions">
                    <button mat-raised-button color="primary" (click)="createGroupFromSelection()"
                        [disabled]="selectedPages.length === 0">
                        <mat-icon>{{ isEditMode ? 'edit' : 'create_new_folder' }}</mat-icon>
                        {{ isEditMode ? 'Editează Grup' : 'Creează Grup' }}
                    </button>
                    <button mat-button (click)="cancelSelection()">
                        Anulează
                    </button>
                </div>
            </div>

            <!-- PDF Canvas Container (Single View) -->
            <div class="pdf-canvas-container" #canvasContainer *ngIf="viewMode === 'single'">
                <canvas #pdfCanvas [class.page-selected]="selectedPages.includes(currentPage)"></canvas>
            </div>

            <!-- Pages Grid Container (Grid View) -->
            <div class="pages-grid-container" *ngIf="viewMode === 'grid'">
                <div class="pages-grid">
                    <div class="page-item-wrapper" *ngFor="let page of pagesList; let i = index">
                        <mat-card class="page-thumb" [class.current-page]="page === currentPage"
                            [class.selected-page]="selectedPages.includes(page)"
                            [class.expanded-group-page]="isPageInExpandedGroup(page)" (click)="goToPage(page)">
                            <mat-card-content>
                                <!-- Canvas pentru miniatura -->
                                <div class="thumb-canvas-container">
                                    <canvas [id]="'thumbnail-' + page" class="page-thumbnail-canvas"
                                        [attr.data-page]="page"></canvas>
                                </div>

                                <div class="thumb-number">{{ page }}</div>
                                <div class="thumb-info" *ngIf="getPageMetadata(page)?.metadata?.title">
                                    <small>{{ getPageMetadata(page)?.metadata?.title || 'Fără titlu' }}</small>
                                </div>
                                <div class="thumb-category" *ngIf="getPageMetadata(page)?.metadata?.category">
                                    <mat-chip class="category-chip">{{ getPageMetadata(page)?.metadata?.category
                                        }}</mat-chip>
                                </div>
                            </mat-card-content>
                        </mat-card>

                        <!-- Buton pentru selecție (în afara card-ului, doar în modul selecție) -->
                        <div class="external-selection-btn" *ngIf="isSelectionMode && canSelectPage(page)">
                            <button mat-mini-fab [color]="selectedPages.includes(page) ? 'warn' : 'primary'"
                                (click)="togglePageSelection(page)"
                                [title]="selectedPages.includes(page) ? 'Scoate din grup' : 'Adaugă în grup'"
                                class="page-selection-btn">
                                <mat-icon>{{ selectedPages.includes(page) ? 'remove' : 'add' }}</mat-icon>
                            </button>
                        </div>

                        <!-- Indicator pentru pagini ocupate -->
                        <div class="page-occupied-indicator" *ngIf="isSelectionMode && !canSelectPage(page)">
                            <mat-icon class="occupied-icon">lock</mat-icon>
                            <span class="occupied-text">În grup</span>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <!-- Sidebar Section (25%) -->
        <div class="sidebar-section">
            <mat-tab-group [(selectedIndex)]="activeTabIndex" class="sidebar-tabs">

                <!-- Grupuri Tab -->
                <mat-tab label="Grupuri">
                    <div class="tab-content">
                        <div class="tab-header">
                            <h3>Grupuri de Documente</h3>
                            <button *ngIf="hasActiveDocumentGroups() && !isSelectionMode" mat-mini-fab color="primary"
                                class="add-group-fab" (click)="startSelection()" title="Creează grup nou">
                                <mat-icon>add</mat-icon>
                            </button>
                        </div>

                        <div *ngIf="hasDocumentGroups(); else noGroupsMessage">
                            <!-- Grupuri Nefinalizate -->
                            <div *ngIf="getNonFinalizedGroups().length > 0" class="groups-section">
                                <div class="section-header">
                                    <h4 class="section-title">
                                        <mat-icon class="section-icon">folder</mat-icon>
                                        Grupuri Active
                                    </h4>
                                    <mat-chip class="groups-count-chip" color="primary">
                                        {{ getNonFinalizedGroups().length }}
                                    </mat-chip>
                                </div>

                                <mat-accordion class="groups-accordion">
                                    <mat-expansion-panel *ngFor="let group of getNonFinalizedGroups(); let i = index"
                                        class="group-panel active-group" (opened)="onGroupExpanded(group, true)"
                                        (closed)="onGroupExpanded(group, false)">
                                        <mat-expansion-panel-header>
                                            <mat-panel-title class="gap-2">
                                                <mat-icon class="group-icon">folder</mat-icon>
                                                {{ group.title || 'Grup ' + (group.group_number || group.id) }}
                                            </mat-panel-title>
                                            <mat-panel-description>
                                                {{ group.total_pages_in_group }} pagini
                                            </mat-panel-description>
                                        </mat-expansion-panel-header>

                                        <div class="group-content ms-4">
                                            <div class="group-pages">
                                                <mat-chip-set>
                                                    <mat-chip *ngFor="let fragment of group.pages"
                                                        (click)="goToPage(fragment)" class="page-chip">
                                                        {{ fragment }}
                                                    </mat-chip>
                                                </mat-chip-set>
                                            </div>

                                            <div *ngIf="!isSelectionMode" class="group-actions">
                                                <div class="group-actions-left">
                                                    <button mat-icon-button (click)="editDocumentGroup(group)"
                                                        title="Editează grup" class="edit-btn">
                                                        <mat-icon>edit</mat-icon>
                                                    </button>
                                                    <button mat-icon-button color="warn" (click)="deleteGroup(group.id)"
                                                        title="Șterge grup" class="delete-btn">
                                                        <mat-icon>delete</mat-icon>
                                                    </button>
                                                </div>
                                                <div class="group-actions-right">
                                                    <button mat-icon-button (click)="finalizeGroup(group)"
                                                        title="Finalizează grup" class="finalize-btn">
                                                        <mat-icon>check_circle</mat-icon>
                                                    </button>
                                                    <!-- <button mat-raised-button color="primary"
                                                        (click)="finalizeGroup(group)" title="Finalizează grup">
                                                        Salvează Modificările
                                                    </button> -->
                                                </div>
                                            </div>
                                        </div>
                                    </mat-expansion-panel>
                                </mat-accordion>
                            </div>

                            <!-- Separator pentru grupuri finalizate -->
                            <mat-divider *ngIf="getFinalizedGroups().length > 0 && getNonFinalizedGroups().length > 0"
                                class="groups-divider"></mat-divider>

                            <!-- Grupuri Finalizate -->
                            <div *ngIf="getFinalizedGroups().length > 0" class="groups-section finalized-section">
                                <div class="section-header">
                                    <h4 class="section-title finalized-title">
                                        <mat-icon class="section-icon finalized-icon">folder_special</mat-icon>
                                        Grupuri Finalizate
                                    </h4>
                                    <mat-chip class="groups-count-chip finalized-chip" color="accent">
                                        {{ getFinalizedGroups().length }}
                                    </mat-chip>
                                </div>

                                <mat-accordion class="groups-accordion finalized-accordion">
                                    <mat-expansion-panel *ngFor="let group of getFinalizedGroups(); let i = index"
                                        class="group-panel finalized-group" (opened)="onGroupExpanded(group, true)"
                                        (closed)="onGroupExpanded(group, false)">
                                        <mat-expansion-panel-header>
                                            <mat-panel-title class="gap-2">
                                                <mat-icon class="group-icon finalized-icon">folder_special</mat-icon>
                                                {{ group.title || 'Grup ' + (group.group_number || group.id) }}
                                            </mat-panel-title>
                                            <mat-panel-description class="finalized-description">
                                                {{ group.total_pages_in_group }} pagini • Finalizat
                                            </mat-panel-description>
                                        </mat-expansion-panel-header>

                                        <div class="group-content ms-4">
                                            <div class="group-pages">
                                                <mat-chip-set>
                                                    <mat-chip *ngFor="let fragment of group.pages"
                                                        (click)="goToPage(fragment)"
                                                        class="page-chip finalized-page-chip">
                                                        {{ fragment }}
                                                    </mat-chip>
                                                </mat-chip-set>
                                            </div>

                                            <div class="group-actions finalized-actions">
                                                <div class="group-actions-center">
                                                    <button mat-icon-button (click)="resetGroupFinalization(group)"
                                                        title="Reactivează grup" class="revert-btn">
                                                        <mat-icon>undo</mat-icon>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </mat-expansion-panel>
                                </mat-accordion>
                            </div>
                        </div>

                        <!-- Mesaj când nu există grupuri -->
                        <ng-template #noGroupsMessage>
                            <div class="no-groups-available">
                                <mat-icon class="large-icon">folder_off</mat-icon>
                                <h3>Nu există grupuri de documente</h3>
                                <p>Creează primul grup pentru a organiza paginile documentului.</p>
                                <div class="no-groups-actions">
                                    <button *ngIf="!isSelectionMode" mat-raised-button color="primary"
                                        (click)="startSelection()" class="create-group-btn">
                                        <mat-icon>create_new_folder</mat-icon>
                                        Creează primul grup
                                    </button>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </mat-tab>

                <!-- Metadate Tab - MODIFICAT cu logica condițională -->
                <mat-tab label="Metadate">
                    <div class="tab-content">
                        <div class="tab-header">
                            <mat-form-field appearance="outline" class="scope-select"
                                [class.disabled-field]="!hasActiveDocumentGroups()">
                                <mat-label>Grup Document</mat-label>
                                <mat-select [(value)]="selectedDocumentGroup"
                                    (selectionChange)="onDocumentGroupChange()" [disabled]="!hasActiveDocumentGroups()">
                                    <mat-option *ngFor="let group of getNonFinalizedGroups()" [value]="group">
                                        {{ group.title}} ({{ group.total_pages_in_group}} pagini)
                                    </mat-option>
                                </mat-select>
                                <mat-hint *ngIf="!hasActiveDocumentGroups()" class="no-groups-hint">
                                    Nu există grupuri active disponibile
                                </mat-hint>
                            </mat-form-field>
                        </div>

                        <!-- Formularul de metadate - afișat doar dacă există grup selectat -->
                        <form class="metadata-form" *ngIf="selectedDocumentGroup && hasDocumentGroups()">
                            <mat-form-field appearance="outline" class="full-width">
                                <mat-label>Titlu</mat-label>
                                <input matInput [(ngModel)]="selectedDocumentGroup.title" name="title"
                                    (change)="saveDocumentGroupMetadata()">
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="full-width">
                                <mat-label>Tip Document</mat-label>
                                <mat-select [(value)]="selectedDocumentGroup.document_type_id"
                                    (selectionChange)="saveDocumentGroupMetadata()"
                                    (openedChange)="onTipuriDocumentSelectClosed()">
                                    <mat-form-field class="px-2 w-100 sticky-input">
                                        <input matInput [formControl]="tipuriDocumentControl"
                                            (keydown)="$event.stopPropagation()" (click)="$event.stopPropagation()" />
                                    </mat-form-field>

                                    <mat-option *ngIf="filteredTipuriDocument.length === 0" disabled>
                                        <span>No results found</span>
                                    </mat-option>

                                    <mat-option *ngFor="let tipDocument of filteredTipuriDocument"
                                        [value]="tipDocument.id">
                                        {{ tipDocument.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="full-width">
                                <mat-label>Descriere</mat-label>
                                <textarea matInput rows="3" [(ngModel)]="selectedDocumentGroup.description"
                                    name="description" (change)="saveDocumentGroupMetadata()"></textarea>
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="full-width">
                                <mat-label>Notițe</mat-label>
                                <textarea matInput rows="4" [(ngModel)]="selectedDocumentGroup.notes" name="notes"
                                    (change)="saveDocumentGroupMetadata()"></textarea>
                            </mat-form-field>

                            <!-- Entitate pentru grup -->
                            <div class="entity-selection">
                                <mat-form-field appearance="outline" class="entity-field">
                                    <mat-label>Entitate pentru Grup</mat-label>
                                    <mat-select [(value)]="selectedDocumentGroup.entity_id"
                                        (selectionChange)="saveDocumentGroupMetadata()"
                                        (openedChange)="onEntitatiGrupSelectClosed()">
                                        <mat-form-field class="px-2 w-100 sticky-input">
                                            <input matInput [formControl]="entitatiGrupControl"
                                                (keydown)="$event.stopPropagation()"
                                                (click)="$event.stopPropagation()" />
                                        </mat-form-field>

                                        <mat-option *ngIf="filteredEntitatiGrup.length === 0" disabled>
                                            <span>No results found</span>
                                        </mat-option>

                                        <mat-option *ngFor="let entitate of filteredEntitatiGrup" [value]="entitate.id">
                                            {{ entitate.name }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </form>

                        <div *ngIf="!hasActiveDocumentGroups()" class="no-groups-available">
                            <mat-icon class="large-icon">folder_off</mat-icon>
                            <h3>Nu există grupuri active de documente</h3>
                            <p>Pentru a adăuga metadate, trebuie să creați mai întâi un grup de documente sau să
                                reactivați un grup finalizat.</p>
                            <div class="no-groups-actions">
                                <button *ngIf="!isSelectionMode" mat-raised-button color="primary"
                                    (click)="startSelection()" class="create-group-btn">
                                    <mat-icon>create_new_folder</mat-icon>
                                    Creează primul grup
                                </button>
                            </div>
                        </div>

                        <!-- Mesaj când există grupuri active dar niciun grup nu este selectat -->
                        <div *ngIf="hasActiveDocumentGroups() && !selectedDocumentGroup" class="no-group-selected">
                            <mat-icon>info</mat-icon>
                            <p>Selectează un grup pentru a edita metadatele</p>
                        </div>

                        <!-- Mesaj când nu există grupuri -->
                        <!-- <div *ngIf="!hasDocumentGroups()" class="no-groups-available">
                            <mat-icon class="large-icon">folder_off</mat-icon>
                            <h3>Nu există grupuri de documente</h3>
                            <p>Pentru a adăuga metadate, trebuie să creați mai întâi un grup de documente.</p>
                            <div class="no-groups-actions">
                                <button mat-raised-button color="primary" (click)="startSelection()"
                                    class="create-group-btn">
                                    <mat-icon>create_new_folder</mat-icon>
                                    Creează primul grup
                                </button>
                            </div>
                        </div> -->

                        <!-- Mesaj când există grupuri dar niciun grup nu este selectat -->
                        <!-- <div *ngIf="hasDocumentGroups() && !selectedDocumentGroup" class="no-group-selected">
                            <mat-icon>info</mat-icon>
                            <p>Selectează un grup pentru a edita metadatele</p>
                        </div> -->
                    </div>
                </mat-tab>

                <!-- Info Tab - MODIFICAT cu design fix -->
                <mat-tab label="Info">
                    <div class="tab-content">
                        <!-- Secțiunea de Management -->
                        <div class="management-section">
                            <h4 class="section-title">Management Document</h4>

                            <!-- Prioritate -->
                            <mat-form-field appearance="outline" class="full-width management-field">
                                <mat-label>Prioritate</mat-label>
                                <mat-select [(value)]="selectedPriority" (selectionChange)="onPriorityChange()">
                                    <mat-option *ngFor="let priority of documentPriorities" [value]="priority.id">
                                        {{ priority.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <!-- Status -->
                            <mat-form-field appearance="outline" class="full-width management-field">
                                <mat-label>Status Document</mat-label>
                                <mat-select [(value)]="selectedStatus" (selectionChange)="onStatusChange()">
                                    <mat-option *ngFor="let status of documentStatuses" [value]="status.id">
                                        {{ status.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <!-- Operator asignat -->
                            <mat-form-field appearance="outline" class="full-width management-field">
                                <mat-label>Operator Asignat</mat-label>
                                <mat-select [(value)]="selectedOperator" (selectionChange)="onOperatorChange()"
                                    (openedChange)="onOperatorAsignatSelectClosed()">
                                    <mat-form-field class="px-2 w-100 sticky-input">
                                        <input matInput [formControl]="operatoriControl"
                                            (keydown)="$event.stopPropagation()" (click)="$event.stopPropagation()" />
                                    </mat-form-field>

                                    <mat-option *ngIf="filteredOperatori.length === 0" disabled>
                                        <span>No results found</span>
                                    </mat-option>

                                    <mat-option *ngFor="let operator of filteredOperatori" [value]="operator.id">
                                        {{ operator.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <!-- Entitate -->
                            <mat-form-field appearance="outline" class="full-width management-field">
                                <mat-label>Entitate Document</mat-label>
                                <mat-select [(value)]="selectedEntityId" (selectionChange)="onEntityChange()"
                                    (openedChange)="onEntitatiSelectClosed()">
                                    <mat-form-field class="px-2 w-100 sticky-input">
                                        <input matInput [formControl]="entitatiControl"
                                            (keydown)="$event.stopPropagation()" (click)="$event.stopPropagation()" />
                                    </mat-form-field>

                                    <mat-option *ngIf="filteredEntitati.length === 0" disabled>
                                        <span>No results found</span>
                                    </mat-option>

                                    <mat-option *ngFor="let entitate of filteredEntitati" [value]="entitate.id">
                                        {{ entitate.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <!-- Buton universal pentru salvare -->
                            <div class="d-flex justify-content-end">
                                <button mat-raised-button color="primary" class="save-changes-btn"
                                    (click)="saveManagementChanges()" [disabled]="!hasManagementChanges()"
                                    *ngIf="hasManagementChanges()">
                                    <mat-icon>save</mat-icon>
                                    Salvează Modificările
                                </button>
                            </div>
                        </div>

                        <mat-divider class="section-divider"></mat-divider>

                        <!-- Informații Document -->
                        <div class="document-info-section">
                            <h3 class="info-section-title">Informații Document</h3>

                            <div class="info-grid">
                                <div class="info-item">
                                    <div class="info-icon">
                                        <mat-icon>description</mat-icon>
                                    </div>
                                    <div class="info-content">
                                        <div class="info-label">Nume document</div>
                                        <div class="info-value-with-edit">
                                            <span class="info-value">{{ data.rowData.display_name }}</span>
                                            <button mat-icon-button class="edit-name-btn" (click)="openEditNameModal()"
                                                title="Editează numele documentului">
                                                <mat-icon>edit</mat-icon>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div class="info-item">
                                    <div class="info-icon">
                                        <mat-icon>code</mat-icon>
                                    </div>
                                    <div class="info-content">
                                        <div class="info-label">Cod document</div>
                                        <div class="info-value">{{ data.rowData.upload_code }}</div>
                                    </div>
                                </div>

                                <div class="info-item">
                                    <div class="info-icon">
                                        <mat-icon>calendar_today</mat-icon>
                                    </div>
                                    <div class="info-content">
                                        <div class="info-label">Data document</div>
                                        <div class="info-value">{{ formatDate(data.rowData.document_date) }}</div>
                                    </div>
                                </div>

                                <div class="info-item">
                                    <div class="info-icon">
                                        <mat-icon>pages</mat-icon>
                                    </div>
                                    <div class="info-content">
                                        <div class="info-label">Total pagini</div>
                                        <div class="info-value">{{ data.rowData.total_pages }}</div>
                                    </div>
                                </div>

                                <div class="info-item">
                                    <div class="info-icon">
                                        <mat-icon>person</mat-icon>
                                    </div>
                                    <div class="info-content">
                                        <div class="info-label">Încărcat de</div>
                                        <div class="info-value">{{ data.rowData.uploaded_by_user_name }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Informații Entitate - doar dacă are entitate asignată -->
                        <div class="entity-info-section" *ngIf="hasAssignedEntity && entityData">
                            <mat-divider class="section-divider"></mat-divider>

                            <h3 class="info-section-title entity-title">
                                <mat-icon>account_box</mat-icon>
                                Entitate Asignată
                            </h3>

                            <div class="info-grid">
                                <div class="info-item">
                                    <div class="info-icon">
                                        <mat-icon>person</mat-icon>
                                    </div>
                                    <div class="info-content">
                                        <div class="info-label">Nume complet</div>
                                        <div class="info-value">{{ entityData.full_name }}</div>
                                    </div>
                                </div>

                                <div class="info-item">
                                    <div class="info-icon">
                                        <mat-icon>badge</mat-icon>
                                    </div>
                                    <div class="info-content">
                                        <div class="info-label">Număr caz</div>
                                        <div class="info-value">{{ entityData.case_number }}</div>
                                    </div>
                                </div>

                                <div class="info-item">
                                    <div class="info-icon">
                                        <mat-icon>fingerprint</mat-icon>
                                    </div>
                                    <div class="info-content">
                                        <div class="info-label">CNP</div>
                                        <div class="info-value">{{ entityData.cnp }}</div>
                                    </div>
                                </div>

                                <div class="info-item">
                                    <div class="info-icon">
                                        <mat-icon>cake</mat-icon>
                                    </div>
                                    <div class="info-content">
                                        <div class="info-label">Data nașterii</div>
                                        <div class="info-value">{{ formatDate(entityData.birth_date) }} ({{
                                            entityData.age }} ani)</div>
                                    </div>
                                </div>

                                <div class="info-item">
                                    <div class="info-icon">
                                        <mat-icon>category</mat-icon>
                                    </div>
                                    <div class="info-content">
                                        <div class="info-label">Tip caz</div>
                                        <div class="info-value">{{ entityData.case_type }}</div>
                                    </div>
                                </div>

                                <div class="info-item" *ngIf="entityData.personal_data?.parintii">
                                    <div class="info-icon">
                                        <mat-icon>family_restroom</mat-icon>
                                    </div>
                                    <div class="info-content">
                                        <div class="info-label">Părinți</div>
                                        <div class="info-value">{{ entityData.personal_data.parintii }}</div>
                                    </div>
                                </div>

                                <div class="info-item" *ngIf="entityData.personal_data?.status">
                                    <div class="info-icon">
                                        <mat-icon>info</mat-icon>
                                    </div>
                                    <div class="info-content">
                                        <div class="info-label">Status</div>
                                        <div class="info-value">{{ entityData.personal_data.status }}</div>
                                    </div>
                                </div>

                                <div class="info-item" *ngIf="entityData.personal_data?.locatie">
                                    <div class="info-icon">
                                        <mat-icon>location_on</mat-icon>
                                    </div>
                                    <div class="info-content">
                                        <div class="info-label">Locație</div>
                                        <div class="info-value">{{ entityData.personal_data.locatie }}</div>
                                    </div>
                                </div>

                                <div class="info-item" *ngIf="entityData.contact_info?.email">
                                    <div class="info-icon">
                                        <mat-icon>email</mat-icon>
                                    </div>
                                    <div class="info-content">
                                        <div class="info-label">Email</div>
                                        <div class="info-value">{{ entityData.contact_info.email }}</div>
                                    </div>
                                </div>

                                <div class="info-item" *ngIf="entityData.contact_info?.telefon">
                                    <div class="info-icon">
                                        <mat-icon>phone</mat-icon>
                                    </div>
                                    <div class="info-content">
                                        <div class="info-label">Telefon</div>
                                        <div class="info-value">{{ entityData.contact_info.telefon }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>

    <!-- Footer Actions - MODIFICAT pentru afișarea condițională -->
    <div class="dialog-footer">
        <div class="footer-left">
            <button mat-button color="warn" (click)="deletePdf()" *ngIf="canDelete">
                <mat-icon>delete</mat-icon>
                Șterge PDF
            </button>
        </div>

        <div class="footer-right">
            <!-- Butonul Salvează Modificările apare doar când suntem pe tab-ul Metadate -->
            <button mat-raised-button color="primary" (click)="saveAllChanges()"
                *ngIf="shouldShowSaveButton && selectedDocumentGroup">
                <mat-icon>save</mat-icon>
                Salvează Modificările
            </button>
        </div>
    </div>
</div>

<!-- Loading Spinner -->
<div class="section-spinner position-fixed" *ngIf="isLoading">
    <div class="spinner position-absolute top-50 start-50 translate-middle">
        <img src="assets/images/dgaspc-logo.svg" height="50%" width="50%" alt="DGASPC" />
        <mat-spinner class="mt-2"></mat-spinner>
        <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
    </div>
</div>

<!-- Group Creation Dialog -->
<div *ngIf="showGroupModal" class="group-modal-overlay">
    <mat-card class="group-creation-dialog">
        <mat-card-header>
            <mat-card-title>Creează Grup Nou</mat-card-title>
        </mat-card-header>
        <mat-card-content class="mt-3">
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Nume Grup</mat-label>
                <input matInput [(ngModel)]="newGroupName" placeholder="Introdu numele grupului">
            </mat-form-field>

            <div class="selected-pages-preview">
                <h4>Pagini selectate:</h4>
                <mat-chip-set>
                    <mat-chip *ngFor="let page of selectedPages" class="selected-page-chip">
                        {{ page }}
                    </mat-chip>
                </mat-chip-set>
            </div>
        </mat-card-content>
        <mat-card-actions class="d-flex flex-row justify-content-between align-items-center mt-3">
            <button mat-button (click)="cancelGroupCreation()">
                Anulează
            </button>
            <button mat-raised-button color="primary" (click)="confirmGroupCreation()">
                Creează
            </button>
        </mat-card-actions>
    </mat-card>
</div>

<div *ngIf="showEditGroupModal" class="group-modal-overlay">
    <mat-card class="group-creation-dialog">
        <mat-card-header>
            <mat-card-title>Editează Grup: {{ editingGroup?.title || 'Grup ' + editingGroup?.id }}</mat-card-title>
        </mat-card-header>
        <mat-card-content class="mt-3">
            <div class="selected-pages-preview">
                <h4>Pagini selectate:</h4>
                <mat-chip-set>
                    <mat-chip *ngFor="let page of selectedPages" class="selected-page-chip">
                        {{ page }}
                    </mat-chip>
                </mat-chip-set>
            </div>
        </mat-card-content>
        <mat-card-actions class="d-flex flex-row justify-content-between align-items-center mt-3">
            <button mat-button (click)="cancelEditGroup()">
                Anulează
            </button>
            <button mat-raised-button color="primary" (click)="confirmEditGroup()">
                Salvează Modificările
            </button>
        </mat-card-actions>
    </mat-card>
</div>

<div *ngIf="showEditNameModal" class="edit-name-modal-overlay">
    <mat-card class="edit-name-dialog">
        <mat-card-header>
            <mat-card-title>
                Editează numele documentului
            </mat-card-title>
        </mat-card-header>

        <mat-card-content class="mt-4">
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Nume document</mat-label>
                <input matInput [(ngModel)]="editingDocumentName" placeholder="Introdu noul nume al documentului"
                    (keyup.enter)="saveDocumentName()" #nameInput>
                <mat-hint>Apasă Enter pentru a salva rapid</mat-hint>
            </mat-form-field>

            <div class="current-name-info">
                <small class="text-muted">
                    <strong>Numele curent:</strong> {{ data.rowData.display_name }}
                </small>
            </div>
        </mat-card-content>

        <mat-card-actions class="d-flex flex-row justify-content-between align-items-center mt-3">
            <button mat-button (click)="cancelEditName()" [disabled]="isSavingName">
                Anulează
            </button>

            <div class="action-buttons">
                <button mat-button color="accent" (click)="resetToOriginalName()"
                    [disabled]="isSavingName || !hasNameChanged()">
                    Resetează
                </button>

                <button mat-raised-button color="primary" (click)="saveDocumentName()"
                    [disabled]="isSavingName || !hasNameChanged() || !isValidName()">
                    <span *ngIf="!isSavingName">Salvează</span>
                    <span *ngIf="isSavingName">Se salvează...</span>
                </button>
            </div>
        </mat-card-actions>
    </mat-card>
</div>